<template>
  <div>
      <page-main
        :tableData="tableData"
        :tablePage="page"
        :loading="loading"
        @reload="reload"
        @openEditFormDialog="openEditFormDialog"
      >
        <page-header
          ref="header"
          slot="header"
          @query="getData"
          @reset="resetPage"
          @openEditFormDialog="openEditFormDialog"
        />
      </page-main>
      <el-dialog
        v-if="editFormDialogOptions.visible"
        show-close
        visible
        width="700px"
        :title="editFormDialogOptions.title"
        :close-on-click-modal="false"
        :before-close="() => $refs.editForm.cancel()"
        v-el-dialog-drag
      >
        <edit-form
          ref="editForm"
          :disabled="editFormDialogOptions.disabled"
          :deAttributeTypeCode="editFormDialogOptions.code"
          @reload="reload"
          @close="closeEditFormDialog"
        />
        <span slot="footer">
          <el-button size="small" @click="$refs.editForm.cancel()">{{
            this.$l("INDEX.btn_cancel") || 取消
          }}</el-button>
          <el-button
            type="primary"
            size="small"
            v-if="!editFormDialogOptions.disabled"
            @click="$refs.editForm.save()"
            >{{ this.$l("INDEX.btn_save") || 保存 }}</el-button
          >
        </span>
      </el-dialog>
  </div>
</template>

<script>
import PageMain from "./main";
import PageHeader from "./header";
import BaseTable from "@/mixins/base-table";
import EditForm from '../left-edit-form/index.vue'
import store from "../../store";
export default {
  components: {
    PageHeader,
    PageMain,
    EditForm,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: ''
      }
    };
  },
  computed: {
    selected() {
      return store.state.selected;
    },
  },
  methods: {
    getData(form) {
      this.loading = true;
      this.$api
        .listDesignElementsDictionaryTypeApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false;
          this.setData(res);
          store.commit("setSelected", this.tableData[0]);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    openEditFormDialog({ type, code = "" }) {
      const types = {
        edit: this.$l("tips_edit") || "编辑素材属性字典类型信息",
        add: this.$l("tips_add") || "增加素材属性字典类型信息",
        detail: this.$l("INDEX.btn_details") || "素材属性字典类型详情",
      };
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        code: code,
        disabled: type === "detail",
      };
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false;
    },
  },
};
</script>
